import AdminLinks from './AdminLinks';

const Navigation = {
	getSidebarLinks(role) {
		return AdminLinks(role);
	},
};

export default Navigation;
